/**
 * Role helpers mirroring the backend's UserRoles / AuthPolicies. The API is the source of truth
 * (User and ReadOnly get 403 on every mutation); these only decide what the UI shows.
 */
export const UserRole = {
  Admin: 'Admin',
  Manager: 'Manager',
  User: 'User',
  ReadOnly: 'ReadOnly',
} as const;

export type UserRole = (typeof UserRole)[keyof typeof UserRole];

/** Roles allowed to create, update, delete, archive, upload and allocate. */
export const MANAGER_ROLES: readonly string[] = [UserRole.Admin, UserRole.Manager];

export function canManage(role: string | null | undefined): boolean {
  return role != null && MANAGER_ROLES.includes(role);
}

export function isAdmin(role: string | null | undefined): boolean {
  return role === UserRole.Admin;
}
